import { Http } from '../../../support';

export const initialState = {
  busy: false,
  data: {},
  progress: 0,
  result: undefined,
  error: undefined,
};

const onChange = (store, data) => {
  store.setState((state) => {
    state.modulo.cancelaciones.upload.data = {
      ...state.modulo.cancelaciones.upload.data,
      ...data,
    };
  });
};

const progress = (store, progress) => {
  store.setState((state) => {
    state.modulo.cancelaciones.upload.progress = progress;
  });
};

const upload = async (store, onUploadProgress = () => {}) => {
  store.setState((state) => {
    state.modulo.cancelaciones.upload.busy = true;
  });

  try {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    };

    const { data } = store.state.modulo.cancelaciones.upload;

    let formData = new FormData();

    formData.append('file', data.file);
    formData.append('tipo', 'cancelaciones');

    const response = await Http.post(`${window.BONJOUR_URL}/api/files/cancelaciones`, formData, options);

    store.setState((state) => {
      state.modulo.cancelaciones.upload.busy = false;
      state.modulo.cancelaciones.upload.progress = 100;
      state.modulo.cancelaciones.upload.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.cancelaciones.upload.busy = false;
      state.modulo.cancelaciones.upload.error = error.data || error;
    });
  }
};

const reset = (store, data) => {
  store.setState((state) => {
    state.modulo.cancelaciones.upload = { ...initialState };
  });
};

const CancelacionesUploadStore = {
  state: () => initialState,
  actions: {
    reset,
    onChange,
    progress,
    upload,
  },
};

export default CancelacionesUploadStore;
